export default __webpack_public_path__ + "766a3c3a6ff9fc39ea98bc1863d877b7.svg";